/// <amd-module name="Likes/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

// LikeInfoPayload doesn't contain the usersinfo as it is fetched separately
export interface LikeInfoPayload {
    isLiked: boolean;
    likeCount: number;
}

export interface LikeState extends LikeInfoPayload {
    topLikedUsers?: string[];
}

export class LikeActions {
    public createLikeStarted = new Action<void>();
    public createLikeFailed = new Action<Error>();
    /**
     * Invoked when state data is changed e.g. it needs to be received by the store
     */
    public likeInfoReceived = new Action<LikeInfoPayload>();
    public deleteLikeStarted = new Action<void>();
    public deleteLikeFailed = new Action<Error>();
    public likedUsersInfoReceived = new Action<string[]>();
}
